module.exports = __webpack_public_path__ + "img/2.f43abc29.png";